import { ITaskModel } from '../../../../../shared/interfaces/task-model.interface';
import { Component, Input } from '@angular/core';

import { getPrettyPropertyRecordCalculationStatus } from '../../../../../shared/enums';

import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-process-details-view-calc-pr-multi-thread',
    templateUrl: './process-details-view-calc-pr-multi-thread.component.html',
    styleUrls: ['./process-details-view-calc-pr-multi-thread.component.scss']
})
export class ProcessDetailsViewCalcPrMultiThreadComponent {
    getPrettyPropertyRecordCalculationStatus;

    constructor() {
        this.getPrettyPropertyRecordCalculationStatus = getPrettyPropertyRecordCalculationStatus;
    }

    @Input()
    public task: ITaskModel;

    statusFormatter(calculationStatusCode: number) {
        return getPrettyPropertyRecordCalculationStatus(calculationStatusCode);
    }
}
